import React from 'react';

function asyncComponent (getComponent) {
  return class AsyncComponent extends React.Component {
    constructor (props) {
      super(props);
      this.state = { Component: AsyncComponent.Component };
    }

    componentWillMount () {
      if (!this.state.Component) {
        getComponent().then((Component) => {
          AsyncComponent.Component = Component;
          this.setState({ Component });
        });
      }
    }

    render () {
      const { Component } = this.state;
      if (Component) {
        return <Component {...this.props} />;
      }
      return null;
    }
  };
}

// loggedApp
export const loggedRoutes = store => ({
  routes: [
    {
      path: '/',
      exact: false,
      component: asyncComponent(() =>
        System.import('./Home').then(module => module.default(store))
      )
    },
  ]
});

// publicApp
export const publicRoutes = store => ({
  routes: [
    {
      path: '/login',
      exact: false,
      component: asyncComponent(() =>
        System.import('./Login').then(module => module.default(store))
      )
    },
  ]
});
